var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1320_1745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.80078 21.5723C6.18164 21.5723 6.46484 21.377 6.92383 20.9473L10.4492 17.7246H17.0508C19.9609 17.7246 21.5234 16.123 21.5234 13.2617V5.78125C21.5234 2.91992 19.9609 1.30859 17.0508 1.30859H4.47266C1.5625 1.30859 0 2.91016 0 5.78125V13.2617C0 16.1328 1.5625 17.7246 4.47266 17.7246H4.93164V20.5664C4.93164 21.1719 5.24414 21.5723 5.80078 21.5723Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1320_1745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.8848,
    height: 21.5723,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble);
export default __webpack_public_path__ + "static/media/bubble.ee5e81c15793f1f5998f7be43f562404.svg";
export { ForwardRef as ReactComponent };